import { isSupportedVariable, parseTextAreaValue } from '../lib/extraVariables';
import _each from 'lodash/each';
import _get from 'lodash/get';

export function isValidSecureUrl(url) {
  let urlRegex =
    /^((https|HTTPS):\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]%@!\$&'\(\)\*\+,;=.]+$/; // eslint-disable-line
  return urlRegex.test(url);
}

export function isValidUrl(url) {
  let urlRegex =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]%@!\$&'\(\)\*\+,;=.]+$/; // eslint-disable-line
  return urlRegex.test(url);
}

export function isValidEmail(email) {
  let emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
}

export function validateExtraVariables(extraVariables) {
  if (!extraVariables) {
    return null;
  }
  const variables = parseTextAreaValue(extraVariables);
  let unsupportedVariables = [];
  _each(variables, (variable) => {
    const key = _get(variable, 'name');
    if (key && !isSupportedVariable(key)) {
      unsupportedVariables.push(key);
    }
  });

  return unsupportedVariables.join(' ');
}

export function byteLength(str) {
  // returns byte length of an utf8 string
  let byteCount = str.length;

  // Based on the ascii code we can tell if the
  // char is of 1 or 2 or 3 bytes.
  for (let i = str.length - 1; i >= 0; i--) {
    let code = str.charCodeAt(i);

    if (code > 0x7f && code <= 0x7ff) {
      byteCount++;
    } else if (code > 0x7ff && code <= 0xffff) {
      byteCount += 2;
    }
    if (code >= 0xdc00 && code <= 0xdfff) {
      i--;
    }
  }
  return byteCount;
}
